import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../../../footer";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import { IoSettingsSharp } from "react-icons/io5";
import { Button } from "react-bootstrap";

const Summary = () => {
  const { runDate: urlRunDate } = useParams(); // Get runDate from URL parameter
  const navigate = useNavigate();
  const [showParameters, setShowParameters] = useState(false);
  const [showReprintModal, setShowReprintModal] = useState(false);
  const [statements, setStatements] = useState([]);
  const [summary, setSummary] = useState({
    total130: 0,
    total3160: 0,
    total6190: 0,
    total91: 0,
    newBalance: 0,
  });
  const [runDates, setRunDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(urlRunDate || "");

  useEffect(() => {
    const fetchRunDates = async () => {
      try {
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/statements/run-dates', {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch run dates");
        }

        const { runDates: fetchedRunDates } = await response.json();
        setRunDates(fetchedRunDates);

        // Set the selected date to the URL date if it exists, otherwise the first available date
        if (urlRunDate && fetchedRunDates.includes(urlRunDate)) {
          setSelectedDate(urlRunDate);
        } else if (fetchedRunDates.length > 0) {
          setSelectedDate(fetchedRunDates[0]);
        }
      } catch (err) {
        setError(err.message);
        console.error("Fetch error:", err);
      }
    };

    const fetchStatements = async () => {
      if (selectedDate) {
        try {
          setLoading(true);
          const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/statements/by-date/${selectedDate}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (!response.ok) {
            throw new Error("Failed to fetch statements");
          }

          const { statements: fetchedStatements, summary: fetchedSummary } = await response.json();
          setStatements(fetchedStatements);
          setSummary(fetchedSummary);
        } catch (err) {
          setError(err.message);
          console.error("Fetch error:", err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchRunDates();
    fetchStatements();
  }, [selectedDate, urlRunDate, navigate]);

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    navigate(`/statements/by-date/${newDate}`); // Update URL with new date
  };

  const handleReprint = () => {
    setShowReprintModal(true);
  };

  const handleCloseModal = () => {
    setShowReprintModal(false);
  };

  const openInNewWindow = (url) => {
    window.open(url, "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
  };

  const handlePrint = () => {
    const printContent = document.getElementById("reprint-modal-content");
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Reprint Statement</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { padding: 10px; text-align: left; }
            th { background-color: #f5f5f5; }
            h2 { margin-bottom: 5px; }
            .footer { margin-top: 20px; color: #666; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  return (
    <>
      <Header />
      <Navvbar />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div className="col-md-10">
            <h2 style={{ margin: 0 }}>Statements Summary {selectedDate || "Loading..."}</h2>
          </div>
          <div className="col-md-2" style={{ padding: "10px", textAlign: "right" }}>
            <button
              style={{
                padding: "10px 15px",
                backgroundColor: "#004aad",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => setShowParameters(!showParameters)}
            >
              <IoSettingsSharp /> Parameters
            </button>
          </div>
        </div>

        {/* Parameters section */}
        {showParameters && (
          <div
            className="row"
            style={{
              marginTop: "10px",
              backgroundColor: "#f5f5f5",
              padding: "15px",
              border: "1px solid #ced4da",
              borderRadius: "5px",
            }}
          >
            <div className="col-md-3">
              <div>
                <label>Account Tags</label>
                <select style={{ width: "100%", padding: "5px", marginTop: "5px" }}>
                  <option>No filter</option>
                </select>
              </div>
              <div style={{ marginTop: "10px" }}>
                <label>Statements</label>
                <select
                  value={selectedDate}
                  onChange={handleDateChange}
                  style={{ width: "100%", padding: "5px", marginTop: "5px" }}
                >
                  {runDates.map((date) => (
                    <option key={date} value={date}>
                      {date}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ marginTop: "10px" }}>
                <label>Format *</label>
                <select style={{ width: "100%", padding: "5px", marginTop: "5px" }}>
                  <option>On Screen</option>
                </select>
              </div>
              <div style={{ marginTop: "10px" }}>
                <button
                  style={{
                    padding: "5px 15px",
                    backgroundColor: "#004aad",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  Run
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Summary section */}
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12">
            <h3 style={{ margin: "10px 0" }}>Summary</h3>
            {loading ? (
              <div>Loading summary...</div>
            ) : error ? (
              <div>Error: {error}</div>
            ) : (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5", borderTop: "2px solid #004aad" }}>
                    <th style={{ padding: "10px", textAlign: "left" }}>1-30</th>
                    <th style={{ padding: "10px", textAlign: "left" }}>31-60</th>
                    <th style={{ padding: "10px", textAlign: "left" }}>61-90</th>
                    <th style={{ padding: "10px", textAlign: "left" }}>91+</th>
                    <th style={{ padding: "10px", textAlign: "left" }}>New Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ backgroundColor: "white" }}>
                    <td style={{ padding: "10px" }}>£{summary.total130.toFixed(2)}</td>
                    <td style={{ padding: "10px" }}>£{summary.total3160.toFixed(2)}</td>
                    <td style={{ padding: "10px" }}>£{summary.total6190.toFixed(2)}</td>
                    <td style={{ padding: "10px" }}>£{summary.total91.toFixed(2)}</td>
                    <td style={{ padding: "10px" }}>£{summary.newBalance.toFixed(2)}</td>
                  </tr>
                  <tr style={{ backgroundColor: "#e9ecef" }}>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px" }}></td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Detail section */}
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12">
            <h3 style={{ margin: "10px 0" }}>Detail</h3>
            {loading ? (
              <div>Loading details...</div>
            ) : error ? (
              <div>Error: {error}</div>
            ) : statements.length > 0 ? (
              statements.map((account) => (
                <div key={account.accountHolder} style={{ marginBottom: "20px" }}>
                  <h4>{account.accountHolder}</h4>
                  <p>Telephone: {account.telephone || "N/A"}</p>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      backgroundColor: "#f5f5f5",
                      marginTop: "10px",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#f5f5f5", borderTop: "2px solid #004aad" }}>
                        <th style={{ padding: "10px", textAlign: "left" }}>Provider Name</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>1-30</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>31-60</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>61-90</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>91+</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>New Balance</th>
                        <th style={{ padding: "10px", textAlign: "left" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {account.providers.map((provider, index) => (
                        <tr key={`${account.accountHolder}-${provider.providerName}-${index}`} style={{ backgroundColor: "white" }}>
                          <td style={{ padding: "10px" }}>{provider.providerName}</td>
                          <td style={{ padding: "10px" }}>£{provider.breakdown.total130.toFixed(2)}</td>
                          <td style={{ padding: "10px" }}>£{provider.breakdown.total3160.toFixed(2)}</td>
                          <td style={{ padding: "10px" }}>£{provider.breakdown.total6190.toFixed(2)}</td>
                          <td style={{ padding: "10px" }}>£{provider.breakdown.total91.toFixed(2)}</td>
                          <td style={{ padding: "10px" }}>£{provider.newBalance.toFixed(2)}</td>
                          <td style={{ padding: "10px" }}>
                            <Button
                              variant="primary"
                              style={{ backgroundColor: "#004aad", color: "white", borderColor: "#004aad" }}
                              onClick={() =>
                                openInNewWindow(
                                  `/reprint-statement?date=${selectedDate}&accountId=${account.accountId}&provider=${encodeURIComponent(provider.providerName)}`
                                )
                              }
                            >
                              Reprint
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <div>No statements found for this date.</div>
            )}
          </div>
        </div>
      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px", marginTop: "15%" }}>
        <Footer />
      </div>
    </>
  );
};

export default Summary;